var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileHalter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 88,
    viewBox: "0 0 69.91 87.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2{fill:none;stroke:#273133;stroke-miterlimit:10;stroke-width:2.07px}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273133",
    d: "M66.71 7.37l2.23-4.19a.78.78 0 000-.58.75.75 0 00-.38-.44L64.24 0l-.66 1.33 3.69 1.82-1.87 3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M28.01 86.25l-21.98.01v-47.1l30.03-11.73 27.71 11.73v47.1H44.25",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M27.05 86V61.55a4.64 4.64 0 014.64-4.64h8.87a4.64 4.64 0 014.64 4.64v24.57m19.32-44.84l4.35-.03-.05-5.58L36.06 21.1 1.11 35.3l-.06 5.71 4.5-.07M2.12 22.51L36.17 8.47l.02 6.9L67.66 2.94M11.9 59.1h9.79v10.06H11.9zm38.73.13h9.51v9.92h-9.51z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M42.32 50.69H30.51a3.21 3.21 0 01-3.21-3.21v-5.72A3.22 3.22 0 0129 38.9l5.92-3a3.21 3.21 0 012.94 0l5.89 3a3.22 3.22 0 011.74 2.86v5.72a3.21 3.21 0 01-3.17 3.21z",
    className: "cls-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileHalter);
export default __webpack_public_path__ + "static/media/file_halter.fe11177a4eec1139daa00fe58b0ffe6c.svg";
export { ForwardRef as ReactComponent };